<template>
  <section :class="$style.page_parts_point">
    <div :class="$style.parts_container">
      <div :class="$style.point_header">
        <div :class="$style.point_num">
          <p>POINT</p>
          <span :class="$style.number"></span>
        </div>
        <p :class="pointTitlePcStyle" v-html="sanitizeHtmlContent(title)"></p>
        <p :class="[$style.point_title, $style.sp]" class="page-parts-sp" v-html="sanitizeHtmlContent(spTitle)"></p>
      </div>
      <div :class="$style.point_img">
        <AtomsConsumerImage :src="imgUrl" :alt="title" :class="{ 'page-parts-pc': spImgUrl }" :width="1280" />
        <AtomsConsumerImage v-if="spImgUrl" :src="spImgUrl" :alt="title" class="page-parts-sp" :width="768" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { sanitizeHtmlContent } from "@tential/ec-gql-schema/utils/functions/sanitize"
type Props = {
  title: string
  spTitle?: string
  imgUrl: string
  spImgUrl?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: "",
  spTitle: "",
  imgUrl: "",
  spImgUrl: "",
})

const style = useCssModule()
const pointTitlePcStyle = computed(() => {
  const isPc = !!props.spTitle
  return [
    style.point_title,
    {
      "page-parts-pc": isPc,
      [style.pc]: isPc,
    },
  ]
})
</script>

<style scoped module lang="scss">
.page_parts_point {
  @include sp {
    .parts_container {
      width: 100%;
    }
  }
  .point_header {
    display: block;
    margin-bottom: 10px;
    @include sp {
      margin: 0 15px 10px;
    }
    .point_num {
      display: inline-block;
      width: 72px;
      height: 72px;
      padding: 12px 10px;
      text-align: center;
      vertical-align: middle;
      background: #c4c4c4;
      @include sp {
        width: 62px;
        height: 62px;
        padding: 7px;
        font-size: 10px;
        .number {
          line-height: 1;
        }
      }
      p {
        font-size: 13px;
        font-weight: 700;
        color: #fff;
        @include sp {
          font-size: 11px;
        }
      }
      .number {
        position: relative;
        counter-increment: number 1;
        &::after {
          font-size: 20px;
          font-weight: 700;
          color: #fff;
          content: counter(number);
        }
      }
    }
    .point_title {
      display: inline-block;
      width: calc(100% - 27px - 80px);
      margin-left: 27px;
      font-size: 24px;
      font-weight: 700;
      line-height: 33px;
      letter-spacing: 3px;
      vertical-align: middle;
      &.pc {
        display: inline-block;
      }
      &.sp {
        display: none;
      }
      @include sp {
        width: calc(100% - 27px - 62px);
        margin-left: 14px;
        font-size: 16px;
        line-height: 30px;
        &.pc {
          display: none;
        }
        &.sp {
          display: inline-block;
        }
      }

      @include sp_5s {
        font-size: 12px;
      }
    }
  }
  .point_img {
    width: 100%;
    height: 455px;
    @include sp {
      height: 280px;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
